import React, { useEffect, useState } from 'react';
import '../../../../styles/globals.css'
import { Box, Button, Checkbox, Grid, TextField, Typography } from '@mui/material'

import { useKarmaPoolContext } from '../../../../state/KarmaPoolContext';
import { Link } from 'react-router-dom';
import Newsletter from '../../newsletter/Newsletter';


function NoteTypeCheckbox({ selectedNoteType, onNoteTypeChange }) {

    return (
        <Grid container spacing={0} sx={{ maxWidth: "30.0rem" }}>
            <Grid item xs={12} sm={3.9} sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Box>
                    <Typography variant="body2" component="div" gutterBottom>
                        note type:
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={4} sm={2.7} sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", marginTop: { xs: "0.5rem", sm: "0.0rem" } }}>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Typography variant="body2" component="div" gutterBottom>
                        music
                    </Typography>
                    <Checkbox
                        sx={{ color: 'white' }}
                        checked={selectedNoteType === "MUSIC"}
                        onChange={() => onNoteTypeChange("MUSIC")}
                    />
                </Box>
            </Grid>
            <Grid item xs={4} sm={2.7} sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", marginTop: { xs: "0.5rem", sm: "0.0rem" } }}>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Typography variant="body2" component="div" gutterBottom>
                        text
                    </Typography>
                    <Checkbox
                        sx={{ color: 'white' }}
                        checked={selectedNoteType === "TEXT"}
                        onChange={() => onNoteTypeChange("TEXT")}
                    />
                </Box>
            </Grid>
            <Grid item xs={4} sm={2.7} sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", marginTop: { xs: "0.5rem", sm: "0.0rem" } }}>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Typography variant="body2" component="div" gutterBottom>
                        image
                    </Typography>
                    <Checkbox
                        sx={{ color: 'white' }}
                        checked={selectedNoteType === "IMAGE"}
                        onChange={() => onNoteTypeChange("IMAGE")}
                    />
                </Box>
            </Grid>
            <Grid item xs={4} sm={2.7} sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", marginTop: { xs: "0.5rem", sm: "0.0rem" } }}>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Typography variant="body2" component="div" gutterBottom>
                        flash
                    </Typography>
                    <Checkbox
                        sx={{ color: 'white' }}
                        checked={selectedNoteType === "FLASH"}
                        onChange={() => onNoteTypeChange("FLASH")}
                    />
                </Box>
            </Grid>
        </Grid>
    );
}

function NoteSubmissionComponent(props) {

    const karmaContext = useKarmaPoolContext();

    const [noteText, setNoteText] = useState(() => {
        return "";
    });

    const handleNoteTextChange = (event) => {
        setNoteText(event.target.value);
    };

    const [url, setUrl] = useState(() => {
        return "";
    });

    const handleUrlChange = (event) => {
        setUrl(event.target.value);
    };

    const [selectedNoteType, setSelectedNoteType] = useState("TEXT");

    const handleNoteTypeChange = (duration) => {
        setSelectedNoteType(duration);
    };

    const [userId, setUserId] = useState("8");

    const handleUserIdChange = (event) => {
        setUserId(event.target.value);
    };

    const [newsletterId, setNewsletterId] = useState(null);

    const handleNewsletterIdChange = (event) => {
        setNewsletterId(event.target.value);
    };

    const handleSubmit = (event) => {
        // Prevent page reload
        event.preventDefault();

        let noteType = "";
        let imageId = undefined;

        if (selectedNoteType === "TEXT") {
            noteType = "NOTE";
        } else if (selectedNoteType === "MUSIC") {
            noteType = "MUSIC_NOTE";
        } else if (selectedNoteType === "IMAGE") {
            noteType = "IMAGE_NOTE";
            imageId = url;
        } else if (selectedNoteType === "FLASH") {
            noteType = "FLASH_NOTE";
        }

        karmaContext.noteManager.postNote({
            newsletterId: newsletterId,
            text: noteText,
            noteType: noteType,
            url: url,
            durationMinutes: 420,
            isNewsletterNote: true,
            extraFields: {
                userId: userId,
                imageId: imageId
            }
        });

        props.resetNoteChoice();
    }

    return (
        <Box sx={{ marginBottom: "0.75rem" }}>
            <Box>
                <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                    <div>
                        <Box sx={{}}>
                            <TextField
                                fullWidth
                                sx={{
                                    backgroundColor: "rgba(221, 221, 221, 0.0825)",
                                    margin: "0.25rem",
                                    width: "18rem", input: { color: 'white' },
                                    label: { color: 'white' }
                                }}
                                id="newletterId"
                                placeholder={"Enter newletter id."}
                                onChange={handleNewsletterIdChange}
                                InputLabelProps={{ shrink: true }}
                                value={newsletterId}
                            />
                        </Box>
                        <Box sx={{}}>
                            <TextField
                                fullWidth
                                multiline
                                sx={{
                                    backgroundColor: "rgba(221, 221, 221, 0.0825)",
                                    margin: "0.25rem",
                                    width: "18rem",
                                    '& textarea': { color: 'white' }, // Update textarea color
                                    '& label': { color: 'white' }, // Update label color
                                }}
                                id="noteText"
                                placeholder={"Enter your note text here."}
                                onChange={handleNoteTextChange}
                                InputLabelProps={{ shrink: false }}
                                value={noteText}
                            />
                        </Box>
                        <Box sx={{}}>
                            <TextField
                                fullWidth
                                sx={{
                                    backgroundColor: "rgba(221, 221, 221, 0.0825)",
                                    margin: "0.25rem",
                                    width: "18rem", input: { color: 'white' },
                                    label: { color: 'white' }
                                }}
                                id="url"
                                placeholder={"Enter url."}
                                onChange={handleUrlChange}
                                InputLabelProps={{ shrink: true }}
                                value={url}
                            />
                        </Box>
                        <Box sx={{}}>
                            <TextField
                                fullWidth
                                sx={{
                                    backgroundColor: "rgba(221, 221, 221, 0.0825)",
                                    margin: "0.25rem",
                                    width: "18rem", input: { color: 'white' },
                                    label: { color: 'white' }
                                }}
                                id="userId"
                                placeholder={"Enter user id to post."}
                                onChange={handleUserIdChange}
                                InputLabelProps={{ shrink: true }}
                                value={userId}
                            />
                        </Box>
                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "1.0rem", marginBottom: "0.25rem" }}>
                            <Box sx={{ width: { xs: "82.5%", sm: "90%" }, maxWidth: "26rem", display: "flex", justifyContent: "center" }}>
                                <NoteTypeCheckbox
                                    selectedNoteType={selectedNoteType}
                                    onNoteTypeChange={handleNoteTypeChange}
                                />
                            </Box>
                        </Box>

                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "0.575rem", marginBottom: "0.25rem" }}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="info"
                                sx={{ backgroundColor: 'rgba(232, 232, 232, 0.5)', marginTop: "1.0rem", marginBottom: "0.75rem" }}>
                                Submit
                            </Button>
                        </Box>

                    </div>
                </form>
            </Box>
        </Box>
    );
}

function NewletterNoteSubmissionChoiceComponent(props) {

    const [noteChoice, setNoteChoice] = useState("NONE");

    const handleText = (event) => {
        // Prevent page reload
        event.preventDefault();
        setNoteChoice("TEXT")
    }

    const handleMusic = (event) => {
        // Prevent page reload
        event.preventDefault();

        setNoteChoice("MUSIC")
    }

    const resetNoteChoice = () => {
        setNoteChoice("NONE")
    }

    return (
        <Box sx={{ marginBottom: "0.05rem", marginTop: "1rem" }}>
            <>
                <Typography variant="body2" component="div" gutterBottom>
                    <strong> Submit a Note </strong>
                </Typography>
                <Box sx={{ marginTop: "0.5rem" }}>
                    <NoteSubmissionComponent resetNoteChoice={resetNoteChoice} />
                </Box>
                <Box sx={{ marginTop: "2.5rem" }}>
                    <Newsletter newsletterId={props.newsletterId} />
                </Box>
            </>

        </Box>
    );
}

export default NewletterNoteSubmissionChoiceComponent;